import styles from './NewIndicators.module.scss'
import { ReactComponent as Icon } from 'icons/circlesvg.svg'
import { ReactComponent as IconCircle } from 'icons/indicator_arc-01.svg'
import { useWindowSize } from 'common/hooks/useWindowSize'
import DataLimits from 'constants/DataLimits'

const NewIndicator = ({
  numericValue,
  littleCircle,
  maxValue = 100,
  levels,
  topColor = '#05CE91'
}) => {
  // the arc has a visual gap at 30 and 65, so we shift values away from those points
  let values
  if (numericValue > 29 && numericValue < 33) {
    values = 29
  } else if (numericValue > 63 && numericValue < 66) {
    values = 63
  } else {
    values = numericValue
  }

  const { width } = useWindowSize()

  const minimumValue = levels?.red ?? DataLimits.INDICATORS_RED
  const maximumValue = levels?.yellow ?? DataLimits.INDICATORS_YELLOW
  const redColor = '#FF3152'
  const yellowColor = '#FFA800'

  const isRedColor = value => {
    return value < minimumValue
  }
  const isYellowColor = value => {
    return value >= minimumValue && value < maximumValue
  }
  const angle = (values * 360) / maxValue

  let color
  if (isRedColor(numericValue)) {
    color = redColor
  } else if (isYellowColor(numericValue)) {
    color = yellowColor
  } else {
    color = topColor
  }

  let radius
  if (width < 965) {
    radius = 32.5
  } else {
    radius = 48.5
  }

  if (littleCircle) {
    radius = 31.5
  }
  const circumference = 2 * Math.PI * radius

  const strokeDasharray = (angle / 360) * circumference
  return (
    <div className={littleCircle ? styles.progress_chart_little : styles.progress_chart}>
      {width < 965 || littleCircle ? (
        <IconCircle className={styles.spaces} />
      ) : (
        <Icon className={styles.spaces} />
      )}
      <svg
        className={
          littleCircle ? styles.progress_chart__circleLittle : styles.progress_chart__circle
        }
      >
        <circle
          className={styles.progress_chart__arc3}
          cx='50%'
          cy='50%'
          r={radius}
          strokeLinecap='round'
          strokeDasharray={[strokeDasharray, circumference - strokeDasharray]}
          strokeDashoffset={0}
          stroke={color}
        />
      </svg>
      <div
        className={
          littleCircle ? styles.progress_chart__percentageLittle : styles.progress_chart__percentage
        }
      >
        {numericValue}
      </div>
    </div>
  )
}
export default NewIndicator
